import { Box, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '@/resources/strings/StringKeys';
import LeftOrgIcon from '@/components/device/LeftOrgIcon';
import LightTooltip from '../utils/LightTooltip';

type LastUserCellProps = {
  displayName: string | null;
  showLeftOrgIcon: boolean;
};

const LastUserCell = ({ displayName, showLeftOrgIcon }: LastUserCellProps) => {
  const { t } = useTranslation();
  const label = t(StringKeys.NOT_A_MEMBER_OF_YOUR_ORGANIZATION);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
      <Typography component="span" variant="inherit" noWrap>
        {displayName ?? '--'}
      </Typography>
      {showLeftOrgIcon && (
        <LightTooltip title={label} placement="bottom" arrow>
          <Box
            component="span"
            aria-label={label}
            sx={{ display: 'inline-flex', flexShrink: 0, lineHeight: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <LeftOrgIcon />
          </Box>
        </LightTooltip>
      )}
    </Box>
  );
};

export default LastUserCell;
